import React, { useEffect } from "react";

import config from "console_config";
import logoAnimationSrc from "src/images/psh-to-upsun-logo-animation-console.gif";

import * as S from "./FullPageRedirect.styles";

export const FullPageRedirect = () => {
  useEffect(() => {
    document.getElementById("fallback")?.remove();
  }, []);

  const search = new URLSearchParams(location.search);
  search.append("from_platform", "true");
  const searchString = `?${search.toString()}`;

  const redirectPath = ["/", searchString, location.hash].join("");

  return (
    <S.Layout>
      <S.GlobalStyles />
      <S.AnimatedLogo src={logoAnimationSrc} alt="Platform.sh to Upsun" />
      <S.Container>
        <S.Title>
          Platform.sh is now <S.TitleUpsun>Upsun</S.TitleUpsun>
        </S.Title>
        <S.FirstParagraph>
          We&apos;ve unified Platform.sh and Upsun to bring you an even better
          experience under one brand. Same powerful platform, enhanced
          capabilities, with a unified vision.
        </S.FirstParagraph>
        <S.Frame />
        <S.H2>Same platform. New capabilities. Fresh look.</S.H2>
        <S.SecondParagraph>
          Your account and projects have been seamlessly migrated to Upsun. No
          action is needed on your part.
        </S.SecondParagraph>
        <S.Ticks>
          <S.TickContainer>
            <S.Tick /> Your projects, workflows and integrations stay exactly as
            they are
          </S.TickContainer>
          <S.TickContainer>
            <S.Tick /> Your service, performance and support continue without
            interruption
          </S.TickContainer>
          <S.TickContainer>
            <S.Tick /> Your pricing plan and account remain unchanged{" "}
          </S.TickContainer>
        </S.Ticks>
        <S.LoginParagraph>
          Log in with your Platform.sh credentials to access your account on
          Upsun.
        </S.LoginParagraph>
        <S.UpsunButton
          target="_self"
          href={config.CUSTOM_FULL_PAGE_REDIRECT + redirectPath}
        >
          Log in to Upsun
        </S.UpsunButton>
      </S.Container>
    </S.Layout>
  );
};
